import {ConnectionUser} from '@lib/store';
import {Workday} from '@lib/store/src/data/timeslots/apiTypes';

export function listConnectionsWithAtLeastOneAppearanceInBuilding(
  allConnections: Array<ConnectionUser>,
  connectionWorkdays: Array<Workday>,
  buildingId: string,
): Array<ConnectionUser> {
  const present = new Set(
    connectionWorkdays
      .filter((wd) => wd.status === 'OfficeDay' && wd.buildingId === buildingId)
      .map((wd) => wd.ownerId),
  );

  return allConnections.filter((c) => present.has(c.id));
}
